import { styled } from '@material-ui/core/styles';
import { MaterialDesignContent } from 'notistack';

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  () => ({
    borderRadius: '120px',
    boxShadow: 'none',
    color: '#EEF0F2',
    fontWeight: 600,
    fontSize: '14px',
    maxWidth: '70vw !important',
    padding: '8px 16px',
    paddingRight: '40px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    '& #notistack-snackbar': {
      flex: '1 1 auto',
      minWidth: 0,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      alignItems: 'center'
    },
    '& div:nth-child(2)': {
      flex: '0 0 auto',
      alignSelf: 'center',
      paddingLeft: 8,
      '& button': {
        '& span svg': {
          color: '#fff',
          fill: '#fff',
          fontSize: '20px'
        }
      }
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: '#1E96FC',
      '& #notistack-snackbar > svg': {
        color: '#fff'
      }
    },
    '&.notistack-MuiContent-success': {
      backgroundColor: '#23A566',
      '& #notistack-snackbar > svg': {
        color: '#fff'
      }
    },
    '&.notistack-MuiContent-warning': {
      backgroundColor: '#FF9F29',
      '& #notistack-snackbar > svg': {
        color: '#fff'
      }
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: '#FA2020',
      '& #notistack-snackbar > svg': {
        color: '#fff'
      }
    }
  })
);
